import http from '@/lib/http'
import { queryClient } from '@/services/queryClient'
import { useMutation, useQuery } from '@tanstack/react-query'

export type CategoryConfigSection = 'prescribers' | 'pharmacists'

export interface CategorySelection {
  included: Array<string>
  excluded: Array<string>
}

export interface CategoryConfigResponse {
  options: Array<string>
  config: Record<CategoryConfigSection, CategorySelection>
}

const QUERY_KEY = ['categoryFilterConfig']
const CURATED_QUERY_KEY = ['curatedCategories']

const fetchCategoryConfig = async () =>
  http.get<CategoryConfigResponse, CategoryConfigResponse>('/prescriber/category-filters')

export const useCategoryConfig = () =>
  useQuery<CategoryConfigResponse>({
    queryKey: QUERY_KEY,
    queryFn: fetchCategoryConfig,
    staleTime: Number.MAX_SAFE_INTEGER
  })

export const useSaveCategoryConfig = () =>
  useMutation({
    mutationFn: async (selection: CategorySelection) => http.put('/prescriber/category-filters', selection),
    // Refresh both the editor's config and the curated chips so a manager sees their save immediately.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
        queryClient.invalidateQueries({ queryKey: CURATED_QUERY_KEY })
      ])
  })

// The lead-curated category chips the current (non-manager) user may filter their own queue by.
const fetchCuratedCategories = async () =>
  http.get<CategorySelection, CategorySelection>('/prescriber/med-requests/curated-categories')

export const useCuratedCategories = () =>
  useQuery<CategorySelection>({
    queryKey: CURATED_QUERY_KEY,
    queryFn: fetchCuratedCategories,
    staleTime: Number.MAX_SAFE_INTEGER
  })
